import { Stack, FieldErrors } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useContext } from "react";

import { BaseLayout } from "./BaseLayout";
import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import {
  CascadiaLayoutProps,
  withCascadiaLayoutProps,
} from "../wrappers/withCascadiaLayoutProps";

function VerticalLayout(props: CascadiaLayoutProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const isSummary = isSummaryForPath?.(props.path);

  const options = props.uischema.options || {};
  const conditionalStyles = !isSummary &&
    options.showDivider && {
      "> *:not(:last-child)": css(styles.divider, {
        paddingBottom: "var(--space-4)",
      }),
      "&:not(:last-child)": css(styles.divider),
    };

  // In rare cases, we don't want to render the summary in block format
  const displayAsBlock =
    isSummary && !options.doNotRenderSummaryInBlockFormat
      ? { display: "block" }
      : undefined;

  return (
    <Stack>
      <BaseLayout
        {...props}
        testID="vertical-layout"
        className={css(
          styles.layout,
          conditionalStyles,
          displayAsBlock,

          options.override_gap && { gap: "var(--space-2)" },
          options.asList && styles.asList
        )}
      />
      {props.touched && <FieldErrors>{props.errors}</FieldErrors>}
    </Stack>
  );
}

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
  asList: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-0)",
  }),
  divider: css({
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderColor: "var(--border-base)",
  }),
};

VerticalLayout.displayName = "VerticalLayout";

export const VerticalLayoutRenderer = withCascadiaLayoutProps(VerticalLayout);
